import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import AdminLayout from "../layouts/AdminLayout";
import DistrictMaster from "../pages/masters/DistrictMaster";
import StateMaster from "../pages/masters/StateMaster";
import PlanCategoryMaster from "../pages/masters/PlanCategoryMaster";
import ProductCategoryMaster from "../pages/masters/ProductCategoryMaster";
import AgeMasterPage from "../pages/masters/AgeMaster";
import ColorMasterPage from "../pages/masters/ColorMaster";
import SizeMasterPage from "../pages/masters/SizeMaster";
import BannerManagement from "../pages/BannerManagement";
import BrandMaster from "../pages/masters/BrandMaster";
import TaxMaster from "../pages/masters/TaxMaster";
import CourierMaster from "../pages/masters/CourierMaster";
import Products from "../pages/Products";
import Supplier from "../pages/Supplier";
import ShippingCharges from "../pages/ShippingCharges";
import Orders from "../pages/Orders";
import Reports from "../pages/Reports";
import Purchase from "../pages/Purchase";
import User from "../pages/User";
import Coupon from "../pages/Coupon";
import Staff from "../pages/Staff";
import Report from "../pages/Report";
import Review from "../pages/Review";
import CheckoutOrder from "../pages/CheckoutOrder";
export default function AppRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route element={<AdminLayout />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/masters/district" element={<DistrictMaster />} />
                    <Route path="/masters/state" element={<StateMaster />} />
                    <Route path="/masters/plan-category" element={<PlanCategoryMaster />} />
                    <Route path="/masters/product-category" element={<ProductCategoryMaster />} />
                    <Route path="/masters/age-category" element={<AgeMasterPage />} />
                    <Route path="/masters/color-category" element={<ColorMasterPage />} />
                    <Route path="/masters/size-category" element={<SizeMasterPage />} />
                    <Route path="/masters/brand" element={<BrandMaster />} />
                    <Route path="/masters/tax" element={<TaxMaster />} />
                    <Route path="/masters/courier" element={<CourierMaster />} />
                    <Route path="/banner" element={<BannerManagement />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/supplier" element={<Supplier />} />
                    <Route path="/shipping-charges" element={<ShippingCharges />} />
                    <Route path="/orders" element={<Orders />} />
                    <Route path="/reports" element={<Reports />} />
                    <Route path="/purchase" element={<Purchase />} />
                    <Route path="/user" element={<User />} />
                    <Route path="/coupon" element={<Coupon />} />
                    <Route path="/staff" element={<Staff />} />
                    <Route path="/report" element={<Report />} />
                    <Route path="/review" element={<Review />} />
                    <Route path="/checkoutorder" element={<CheckoutOrder />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}